(function () {
  function setLanguage(language) {
    var next = language === 'es' ? 'es' : 'en';
    document.querySelectorAll('[data-language-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-language-panel') !== next;
    });
    document.documentElement.lang = next;
    try { window.localStorage.setItem('fast-lane-language', next); } catch (error) { /* Storage can be unavailable in preview. */ }
  }

  function initLanguageToggle() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-language-choice]');
      if (!button) return;
      event.preventDefault();
      setLanguage(button.getAttribute('data-language-choice'));
    });
    var saved = 'en';
    try { saved = window.localStorage.getItem('fast-lane-language') || 'en'; } catch (error) { /* Use English. */ }
    setLanguage(saved);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLanguageToggle);
  else initLanguageToggle();
})();
